import styled from 'styled-components';
import {Space} from 'antd';

const StyledTotalCardsBalance = styled(Space)`
  width: 100%;
`;

export {
  StyledTotalCardsBalance,
}
